<button class="button outside-cycles__button"
    type="button"
    (click)="onClick()">
  <span class="text text_bold text_small outside-cycles__text"
    [class.outside-cycles__text_active]="active">
    <ng-content></ng-content>
  </span>
</button>

